<template>
  <div>

    <header class="menu">
      <section class="top">
          <a href="./"><img src="/static/img/app/logom.png?v=1.0" class="logo" style="height: 41px;" /></a>

      <div class="anchors text-right">

        <ul class="list-inline" >

          <li class="dropdown "><!-- hidden-xs hidden-sm -->

            <a class="dropdown-toggle" data-toggle="dropdown" href="#"
               role="button" aria-haspopup="true" aria-expanded="false">
                <div class="hidden-xs hidden-sm">{{user.name}} &nbsp; <i class="fa fa-angle-down"></i></div>
                <div class="visible-xs visible-sm"><i class="fa fa-user"></i></div>
            </a>

            <div class="dropdown-menu dropdown-menu-right">
              <!--<a class="dropdown-item" href="./mis-datos">Mi Cuenta</a>-->
              <router-link class="dropdown-item" to="/myorders">Mis Compras</router-link>


              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" @click.prevent="logout">Salir</a>
            </div>

          </li>

          <li >
            <a class="openMyCart">
              <i class="fa fa-shopping-cart"></i> &nbsp;
              <span class="">
                 <span class="cantidad" v-if="cart_total>0">{{cart_items.length}} prod.</span>
                  <span class="cantidad hidden-xs hidden-sm" v-else>Sin productos</span>
              </span>
            </a>

          </li>

          <!--
          <li class="left-line">
            <a class="openSearch">
              <i class="fa fa-search"></i><span class="hidden-xs hidden-sm"> &nbsp; Buscar</span>
            </a>
          </li>
          -->
        </ul>



      </div>

    </section>

      <section class="bottom">
      <ul>
        <li>
          <router-link to="/">HOME</router-link>
        </li>

        <li v-for="category in categories" :key="category.id">
          <router-link :to="'/category/'+category.id" >{{category.name}}</router-link>
        </li>

      </ul>
    </section>

    </header>

    <div class="compensate-header"></div>

  </div>
</template>

<script>

    import Api from '@/Api'
    import { mapGetters } from 'vuex';

    export default {
        data(){
          return {
            categories:[],
            search: ''
          }
        },
        computed: {
          ...mapGetters(['user','isLogged','cart_total','cart_items']),
          items() {
                return product.filter(item => {
                  return item.description.toLowerCase().includes(this.search.toLowerCase());
                });
              },
        },
        methods:{
          logout(){
            this.$store.dispatch('logout', this)
              .then(() => {
                this.$router.push({name: 'Login'});
              })
              .catch(err => {

              });
          }
        },
        mounted(){

            Api().get('categories').then(data=>{
              if (data.data.status===1){
                this.categories = data.data.data;
              }else{
                this.categories = [];
              }

            }).catch(err=>{

            });



        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HeaderPartial.vue